/**
 * ApprovalModeButton Component
 *
 * Button in gallery toolbar to open approval workflow.
 * Shows badge with pending image count.
 */

import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, Badge } from '@/components/v2/ui';
import { useApprovalStats } from '@/hooks/useApproval';

export interface ApprovalModeButtonProps {
  onClick: () => void;
}

export function ApprovalModeButton({ onClick }: ApprovalModeButtonProps) {
  const { t } = useTranslation();
  const { data: stats, isLoading } = useApprovalStats();

  const pendingCount = stats?.pending || 0;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      className="flex items-center gap-2 relative"
      disabled={isLoading}
    >
      <CheckCircle className="h-4 w-4" />
      {t('settings.approvalWorkflow')}
      {pendingCount > 0 && (
        <Badge
          variant="default"
          className="ml-1 bg-orange-500 text-white px-2 py-0.5 text-xs"
        >
          {pendingCount}
        </Badge>
      )}
    </Button>
  );
}
